import React from "react";
import styles from "../assets/component.css";
import GLLogo from "../../../NTICore/assets/img/gl_logo.png";

export const FooterPage = () => {
  return (
    <React.Fragment>
      <div>
        <img
          src={GLLogo}
          alt={"GreenLink Logo"}
          className={styles.footerLogo}
        />
      </div>
      <span style={{color: '#ffffff'}}>
        122 W John Carpenter Fwy #540, Irving, TX 75039 • (888) 972 8802 • partners@greenlinknetworks.com
      </span>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Layout/FooterPage.js